export const MINIMUM_CHARACTERS_SEARCH = 3;
export const MAXIMUM_CHARACTERS_SEARCH = 200;
